import { themes } from 'mdx-deck';
import addCommit from "../../../../images/addcommit.png";
import comic from "../../../../images/comic.png";
import graph from "../../../../images/graph.jpeg";
import comparison from "../../../../images/svn-vs-git.jpeg";
import React from 'react';
export default {
  themes,
  addCommit,
  comic,
  graph,
  comparison,
  React
};